'use strict';

var copy = require('shallow-copy');

var addCounts = require('../lib/add-counts');
var checklist = require('../refinement-types/checklist');

var refine = function refine(workTypes, params, allCounts) {
  var counts = allCounts && allCounts.worktype;

  return {
    worktype: workTypes.map(function (worktype) {
      var newWorkType = addCounts(copy(worktype), counts);

      newWorkType.isActive = checklist.includes(params, 'worktype', newWorkType.value);
      newWorkType.refineParams = checklist.remove(checklist.toggle(params, 'worktype', newWorkType.value), 'worktype', '0');

      return newWorkType;
    })
  };
};

module.exports = refine;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/refinements/worktype.js
 ** module id = 491
 ** module chunks = 0
 **/